import * as React from 'react';
import { jsx, ThemeProvider as ThemeProvider$1 } from '@emotion/react';

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme;
  React.useEffect(function () {
    var isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      window.theme = theme;
    }
  }, [theme]);
  return jsx(ThemeProvider$1, {
    theme: theme
  }, children);
};
ThemeProvider.displayName = 'ThemeProvider';

export { ThemeProvider };
//# sourceMappingURL=theme-provider.js.map
